/**
 *
 * lore
 * {
    *  account_id
        create_time
        describe
        interaction
        lore_id
        micro_lecture
        name
        state
        update_time
    }
    {
        "code":0,
        "ret":
        [
            {
                "id":1,
                "name":"荒宅疑凶（密室逃脱）",
                "difficulty":5,
                "novelty":5,
                "duration":30,
                "number_min":2,
                "number_max":4,
                "type":null,
                "hot":null,
                "introduction":"恐怖、惊险、悬疑、烧脑……港城近几个月来发生了数起人口失踪案件。已经造成了一定的社会恐慌。你们作为市警局最精英的探员，为了查清案件的真相，今晚将潜入城南山顶别墅区的一栋“旧宅”解开重重疑团。"},{"id":2,"name":"仙剑奇侠传四","difficulty":4,"novelty":5,"duration":30,"number_min":2,"number_max":4,"type":null,"hot":null,"introduction":"大战之后，天道轮回，此番几位高手现世，又会预兆什么天地劫难，韩菱纱和云天河从中助力，你将化身慕容紫英的亲传弟子，御剑飞仙至不周山感受仙魔大战。"},{"id":3,"name":"鬼魅聊斋","difficulty":4,"novelty":5,"duration":30,"number_min":2,"number_max":4,"type":null,"hot":null,"introduction":"“只要能和你在一起，就算万劫不复，飘荡在这阴阳边界，我也愿意。”聂小倩和宁采臣的旷世奇恋，阴阳两界的纠缠羁绊，怕再料事如神的捉妖师都一筹莫展不知如何是好。为情所困的聂小倩俘获了万兽之王白泽的女儿阿黎，封印在兰若寺的壁画之中。此行异常凶险，在荒废古刹兰若寺等待你的，究竟是什么。"},{"id":5,"name":"丧尸围攻","difficulty":4,"novelty":5,"duration":25,"number_min":2,"number_max":4,"type":null,"hot":null,"introduction":"和特战队员们一起潜入恐怖组织的秘密基地，击败如潮水般涌来的僵尸和改造生命体，破坏病毒实验室和感染源，拯救世界"},{"id":6,"name":"踩雷大师","difficulty":2,"novelty":3,"duration":25,"number_min":2,"number_max":6,"type":null,"hot":null,"introduction":"在奇幻的世界中，躲避陷阱、炸弹，击败对手，夺旗取胜，燃烧你的卡路里，化身VR版炸弹人"},{"id":7,"name":"陷落计划","difficulty":3,"novelty":3,"duration":22,"number_min":2,"number_max":6,"type":null,"hot":null,"introduction":"这是一份来自外太空的邀请函。两个文明在木星环相遇，生存还是毁灭，战争以外是否在相互理解的可能，获得最终的答案需要你们的勇气和智慧"},{"id":8,"name":"阿修罗","difficulty":2,"novelty":3,"duration":20,"number_min":2,"number_max":6,"type":null,"hot":null,"introduction":"在阿修罗界反抗军战士图卡的带领下，你们克服重重困难，击败了阿修罗王的众多爪牙，最终找到了阿修罗王的贪婪之心并齐心合力将其击碎，一举消灭了阿修罗王，挽了救整个六界和芸芸众生"
            }
        ]
    }
            */

import {
  gUtilityLocalStorage
} from "../utility/UtilityLocalStorage";

export const gGameData = {

  m_data: null, //游戏数据
  //解析服务器返回的游戏数据
  parseProtocal: function(data) {
    this.m_data = data;
    sessionStorage.setItem("m_data", JSON.stringify(this.m_data));
  },
  get_data: function() {
    if (null == this.m_data) {
      this.m_data = JSON.parse(sessionStorage.getItem("m_data"));
    }
    return this.m_data;
  },
  //返回所有游戏数据
  getAllData: function() {
    this.get_data();
    this.getAllGameData();
    var ret = new Array;
    for (let index = 0; index < this.m_data.length; index++) {
      const element = this.m_data[index];
      ret.push({
        "name": element.name,
        "id": element.id
      });
    }
    return ret;
  },
  //返回指定ID的游戏数据
  getDataByID: function(id) {
    this.get_data();
    this.getAllGameData();
    var ret = new Array;
    console.log(this.m_all_game_data);
    for (let index = 0; index < this.m_all_game_data.length; index++) {
      const element = this.m_all_game_data[index];
      if (element.id == id) {
        return element;
      }
    }
    return null;
  },
  //返回指定ID的游戏数据
  getDataByName: function(name) {
    this.get_data();
    this.getAllGameData();
    var ret = new Array;
    for (let index = 0; index < this.m_all_game_data.length; index++) {
      const element = this.m_all_game_data[index];
      if (element.name == name) {
        return element;
      }
    }
    return null;
  },

  m_shop_data: null, //店铺游戏数据
  //解析服务器返回的店铺游戏数据
  parseProtocalShopData: function(data) {
    var ret = new Array;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      var game_data = this.getDataByID(element.id);
      if (null == game_data) {
        continue;
      }
      ret.push({
        "name": game_data.name,
        "id": game_data.id
      });
    }
    this.m_shop_data = ret;
    sessionStorage.setItem("m_shop_data", JSON.stringify(this.m_shop_data));
  },
  get_shop_data: function() {
    if (null == this.m_shop_data) {
      this.m_shop_data = JSON.parse(sessionStorage.getItem("m_shop_data"));
    }
    return this.m_shop_data;
  },
  //返回所有店铺游戏数据
  getAllDataShopData: function() {
    this.get_shop_data();
    var ret = new Array;
    for (let index = 0; index < this.m_shop_data.length; index++) {
      const element = this.m_shop_data[index];
      ret.push({
        "name": element.name,
        "id": element.id
      });
    }
    return ret;
  },
  m_shop_data_price:null,
  //提交所有店铺游戏数据(带游戏价格的)
  setAllDataShopDataPrice : function(data)
  {
    this.m_shop_data_price = data;
    sessionStorage.setItem("m_shop_data_price", JSON.stringify(this.m_shop_data_price));
  },
  //返回所有店铺游戏数据(带游戏价格的)
  getAllDataShopDataPrice: function() {
    if (null == this.m_shop_data_price) {
      this.m_shop_data_price = JSON.parse(sessionStorage.getItem("m_shop_data_price"));
    }
    return this.m_shop_data_price;
  },
  m_data_playing: null, //店铺进行中的游戏数据
  //解析服务器返回的店铺进行中的游戏数据
  parseProtocalPlaying: function(data) {
    var ret = new Array;
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      var game_data = this.getDataByID(element.game_id);
      ret.push({
        "name": game_data.name,
        "time_start": element.time_start,
        "game_id": game_data.id,
        "duration": game_data.duration,
        "id": element.id,
		    "remarks": element.remarks,
        "max_user_count":element.max_user_count,
        "signature_string":element.signature_string,
		    "hall_type": element.hall_type,
        "start_time": element.time_start,
        "game_start_time": element.game_start_time,
      });
    }
    this.m_data_playing = ret;
    sessionStorage.setItem("m_data_playing", JSON.stringify(this.m_data_playing));
  },
  get_data_playing: function() {
    if (null == this.m_data_playing) {
      this.m_data_playing = JSON.parse(sessionStorage.getItem("m_data_playing"));
    }
    return this.m_data_playing;
  },
  //返回店铺进行中的游戏数据
  getAllDataPlaying: function() {
    this.get_data_playing();
    var ret = new Array;
    for (let index = 0; index < this.m_data_playing.length; index++) {
      const element = this.m_data_playing[index];
      ret.push({
        "name": element.name,
        "time_start": this.timestampToTime(element.time_start),
        "duration": element.duration,
        "id": element.id,
        "remarks": element.remarks,
        "max_user_count":element.max_user_count,
        "signature_string":element.signature_string,
        "hall_type": element.hall_type,
        "start_time": element.time_start,
        "game_id": element.game_id,
        "game_start_time": this.timestampToTime(element.game_start_time),
      });
    }
    return ret;
  },

  timestampToTime: function(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-';
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var D = date.getDate() + ' ';
    var h = date.getHours() + ':';
    var m = date.getMinutes() + ':';
    var s = date.getSeconds();
    return Y + M + D + h + m + s;
  },


  m_all_game_data: null, //全部游戏数据包含已下线的数据
  //全部游戏数据包含已下线的数据
  parseAllGameDataProtocal: function(data) {
    this.m_all_game_data = data;
    sessionStorage.setItem("m_all_game_data", JSON.stringify(this.m_all_game_data));
  },

  getAllGameData: function() {
    if (null == this.m_all_game_data) {
      this.m_all_game_data = JSON.parse(sessionStorage.getItem("m_all_game_data"));
    }
    return this.m_all_game_data;
  },
  //返回指定ID的游戏数据从全部游戏数据包含已下线的数据
  getDataByIDFromAllGameData: function(id) {
    this.getAllGameData();
    for (let index = 0; index < this.m_all_game_data.length; index++) {
      const element = this.m_all_game_data[index];
      if (element.id == id) {
        return element;
      }
    }
      console.log(this.m_all_game_data)
    console.log(id)
    return null;
  },

};



// WEBPACK FOOTER //
// ./src/assets/js/data/GameData.js